import { Link } from 'react-router-dom'
import { useAppSelector } from '../../app/store'
import { Emblem } from '../../ui/brand/Emblems'
import { AuthFrame } from './AuthFrame'
import { PlatformEntry } from './PlatformEntry'

/** `/`: in a browser — the landing with sign-in; on VK and Yandex — the platform entry. */
export function Landing() {
  const platform = useAppSelector(s => s.session.platform)
  const signedIn = useAppSelector(s => s.session.signedIn)
  if (platform !== 'web') return <PlatformEntry platform={platform} />
  return (
    <AuthFrame title="Межа" sub="Где-то в тридесятом царстве" wide>
      <p className="auth__lead">У пограничного столба стёрлось имя дороги. Разберитесь, кто это сделал, пока спор не дошёл до мечей.</p>
      <ul className="auth__facts">
        <li><Emblem name="nav.map" />Клеточная карта края: шаги, встречи, рыбалка и травы</li>
        <li><Emblem name="arena.duel" />Пошаговые бои: удар, защита и тактика каждый раунд</li>
        <li><Emblem name="nav.journal" />Сюжет с выборами, которые записываются в журнал</li>
        <li><Emblem name="nav.clans" />Арена, кланы и покровители</li>
      </ul>
      <div className="auth__actions">
        {signedIn ? (
          <Link className="plank plank--gold" to="/play"><span className="plank__in">Продолжить</span></Link>
        ) : (
          <>
            <Link className="plank plank--gold" to="/register"><span className="plank__in">Начать игру</span></Link>
            <Link className="plank" to="/login"><span className="plank__in">Войти</span></Link>
          </>
        )}
      </div>
    </AuthFrame>
  )
}
